// extracted by mini-css-extract-plugin
var _1 = "HzPMXxhU99ph4gTJSvjj";
var _2 = "u3zdMQg26Vi31cO0LXst";
var _3 = "pyb2knXFCw2RETUeJWMq";
var _4 = "#000000";
var _5 = "#76F366";
var _6 = "#EB8632";
var _7 = "#ECC834";
var _8 = "#21FC87";
var _9 = "#EA4A30";
var _a = "#C7EA45";
var _b = "#272B2B";
var _c = "#BDBDBD";
var _d = "#7D7D7D";
var _e = "#6A0DAD";
var _f = "#3A65FF";
var _10 = "#4A90E2";
var _11 = "#ffffff";
var _12 = "pg2vHTqK2tAjReXffdlO";
var _13 = "Qx5yIs0ZZor4QLInrKsU";
var _14 = "yu8MbEncfhnWLNYO3tHI";
var _15 = "GjmE8Ogk3BS4Zhd8TyeY";
var _16 = "s2Q__2EW2fTzP9xuFFhQ";
var _17 = "pbNdKpUVhGsgUNawXMS7";
var _18 = "1200px";
var _19 = "992px";
var _1a = "1366px";
var _1b = "768px";
var _1c = "1475px";
var _1d = "576px";
var _1e = "1600px";
var _1f = "320px";
var _20 = "2500px";
var _21 = "rrYZgYtqPRwj74hmOTr3";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "clock", _4 as "colorBlack", _5 as "colorGradeEX", _6 as "colorGradeFR", _7 as "colorGradeGD", _8 as "colorGradeOU", _9 as "colorGradePR", _a as "colorGradeVG", _b as "colorNeutral", _c as "colorNeutralLighest", _d as "colorNeutralLight", _e as "colorNonOwnerSweetLine", _f as "colorOwnerSweetLine", _10 as "colorRegularLinks", _11 as "colorWhite", _12 as "destination", _13 as "emptyPlaceholder", _14 as "folder", _15 as "forwardDestinationList", _16 as "icon", _17 as "reset-button", _18 as "screenlg", _19 as "screenmd", _1a as "screenml", _1b as "screensm", _1c as "screenxlg", _1d as "screenxs", _1e as "screenxxlg", _1f as "screenxxs", _20 as "screenxxxlg", _21 as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "base-link": _2, "clock": _3, "colorBlack": _4, "colorGradeEX": _5, "colorGradeFR": _6, "colorGradeGD": _7, "colorGradeOU": _8, "colorGradePR": _9, "colorGradeVG": _a, "colorNeutral": _b, "colorNeutralLighest": _c, "colorNeutralLight": _d, "colorNonOwnerSweetLine": _e, "colorOwnerSweetLine": _f, "colorRegularLinks": _10, "colorWhite": _11, "destination": _12, "emptyPlaceholder": _13, "folder": _14, "forwardDestinationList": _15, "icon": _16, "reset-button": _17, "screenlg": _18, "screenmd": _19, "screenml": _1a, "screensm": _1b, "screenxlg": _1c, "screenxs": _1d, "screenxxlg": _1e, "screenxxs": _1f, "screenxxxlg": _20, "single-page-responsive-font-size": _21 }
